import {createAction} from 'Shared/utilities/actionCreator';
import {ofType, unionize, UnionOf} from 'unionize';

enum agentVerificationActionTypes {
  CHANGE_VERIFICATION = 'agentVerification/CHANGE_VERIFICATION',
}

type EmptyVerification = {};
type PendingVerification = {
  verificationCode: string;
};
type SuccessfulVerification = {};
type FailedVerification = {};

export const Verification = unionize({
  Empty: ofType<EmptyVerification>(),
  Failed: ofType<FailedVerification>(),
  Pending: ofType<PendingVerification>(),
  Successful: ofType<SuccessfulVerification>(),
});
export type VerificationUnion = UnionOf<typeof Verification>;

export const changeVerification = (verification: VerificationUnion) =>
  createAction(agentVerificationActionTypes.CHANGE_VERIFICATION, {
    verification,
  });

type AgentVerificationActions = ReturnType<typeof changeVerification>;

export type AgentVerificationState = {
  verification: VerificationUnion;
};

export const DEFAULT_STATE: AgentVerificationState = {
  verification: Verification.Empty(),
};

export default (state = DEFAULT_STATE, action: AgentVerificationActions): AgentVerificationState => {
  switch (action.type) {
    case agentVerificationActionTypes.CHANGE_VERIFICATION:
      return {
        ...state,
        verification: action.payload.verification,
      };
    default:
      return state;
  }
};
